<mat-toolbar>
  <h1>Commission</h1>
  <span class="spacer"></span>
</mat-toolbar>

<div class="grid">
  <div class="c-12">
    <table mat-table [dataSource]="source()" [trackBy]="trackBy" multiTemplateDataRows>
      <tr mat-header-row *matHeaderRowDef="columnsToShow()"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: columnsToShow()"
        (click)="toggle(row.Number)"
        style="cursor: pointer"
      ></tr>
      <tr mat-row *matRowDef="let row; columns: ['invoices']" [hidden]="!expanded()[row.Number]"></tr>

      <ng-container matColumnDef="ClientCode">
        <th mat-header-cell *matHeaderCellDef>Client Code</th>
        <td mat-cell *matCellDef="let item">{{ item.ClientCode }}</td>
      </ng-container>

      <ng-container matColumnDef="Number">
        <th mat-header-cell *matHeaderCellDef matTooltip="Job/Agreement number">#</th>
        <td mat-cell *matCellDef="let item">{{ item.Number }}</td>
      </ng-container>

      <ng-container matColumnDef="Title">
        <th mat-header-cell *matHeaderCellDef>Title</th>
        <td mat-cell *matCellDef="let item">
          <a title="View" [routerLink]="[item.LinkBase, item.Number]"> {{ item.Title }} </a>
        </td>
      </ng-container>

      <ng-container matColumnDef="Type">
        <th mat-header-cell *matHeaderCellDef>Type</th>
        <td mat-cell *matCellDef="let item">{{ item.Type }}</td>
      </ng-container>

      <ng-container matColumnDef="InvoiceAmount">
        <th mat-header-cell *matHeaderCellDef>Invoice amount</th>
        <td mat-cell *matCellDef="let item">${{ item | totalCommissionAmount | number }}</td>
      </ng-container>

      <ng-container matColumnDef="Commission">
        <th mat-header-cell *matHeaderCellDef>Commission</th>
        <td mat-cell *matCellDef="let item">${{ (item | totalCommissionAmount) * 0.05 | number: '.0-2' }}</td>
      </ng-container>

      <ng-container matColumnDef="invoices">
        <td mat-cell *matCellDef="let item" [attr.colspan]="columnsToShow().length" style="padding: 1rem">
          <table mat-table [dataSource]="invoices()[item.Number]">
            @let columns = ['Date', 'Notes', 'Amount', 'Commission'];
            <tr mat-header-row *matHeaderRowDef="columns"></tr>
            <tr mat-row *matRowDef="let row; columns: columns"></tr>

            <ng-container matColumnDef="Date">
              <th mat-header-cell *matHeaderCellDef>Date</th>
              <td mat-cell *matCellDef="let item">{{ item.InvoiceDate | date: 'dd/MM/yyyy' }}</td>
            </ng-container>

            <ng-container matColumnDef="Notes">
              <th mat-header-cell *matHeaderCellDef>Notes</th>
              <td mat-cell *matCellDef="let item">{{ item.Notes }}</td>
            </ng-container>
            <ng-container matColumnDef="Amount">
              <th mat-header-cell *matHeaderCellDef>Invoice amount</th>
              <td mat-cell *matCellDef="let item">${{ item.InvoiceAmount | number }}</td>
            </ng-container>
            <ng-container matColumnDef="Commission">
              <th mat-header-cell *matHeaderCellDef>Commission</th>
              <td mat-cell *matCellDef="let item">${{ item.InvoiceAmount * 0.05 | number: '.0-2' }}</td>
            </ng-container>
          </table>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let item">
          <mat-icon>{{ expanded()[item.Number] ? 'unfold_less' : 'unfold_more' }}</mat-icon>
        </td>
      </ng-container>
    </table>
  </div>
</div>
